import {clickEvent, dispatchCustomEvent, keyupEvent} from "../../webpack/modules/events";
import {hideElement, slideDown, slideUp} from "../../webpack/modules-optimized/element-visibility";
import {getTextPreview} from "../../webpack/modules-optimized/up-selling-personalized-text";
import {calculatePrice} from "../../webpack/modules-optimized/product";
import {formatPrice} from "../../webpack/modules-optimized/price";

clickEvent('#personalized-text-pop-up .open-font-selector', true, async function() {
    let button = document.querySelector('#personalized-text-pop-up .open-font-selector');
    let fontSelector = document.querySelector('#personalized-text-pop-up .font-selector');
    let colorSelector = document.querySelector('#personalized-text-pop-up .color-selector');
    let isColorSelectorShowed = (colorSelector.offsetWidth && colorSelector.offsetHeight);

    if (isColorSelectorShowed) await closeColorSelector();
    await slideDown(fontSelector);
    button.classList.remove('open-font-selector', 'border-dark');
    button.classList.add('close-font-selector', 'text-primary', 'border-primary');
});

clickEvent('#personalized-text-pop-up .close-font-selector', true, closeFontSelector);

clickEvent('#personalized-text-pop-up .open-color-selector', true, async function() {
    let button = document.querySelector('#personalized-text-pop-up .open-color-selector');
    let colorSelector = document.querySelector('#personalized-text-pop-up .color-selector');
    let fontSelector = document.querySelector('#personalized-text-pop-up .font-selector');
    let isFontSelectorShowed = (fontSelector.offsetWidth && fontSelector.offsetHeight);

    if (isFontSelectorShowed) await closeFontSelector();
    await slideDown(colorSelector);
    button.classList.remove('open-color-selector');
    button.classList.add('close-color-selector');
});

clickEvent('#personalized-text-pop-up .close-color-selector', true, closeColorSelector);

clickEvent('#personalized-text-pop-up .font-group-title', true, async function(element) {
    let body = element.closest('.font-group').querySelector('.font-group-body');
    let bodyIsShow = (body.offsetWidth && body.offsetHeight);
    let previousVisibleFontGroup = document.querySelector('#personalized-text-pop-up .font-group-body[style*="display: block"]');

    await slideUp(previousVisibleFontGroup);
    if (!bodyIsShow) slideDown(body);
});

clickEvent('#personalized-text-pop-up .font', true, function(font) {
    let file = font.dataset.file;
    let name = font.dataset.name;
    let rtl = font.dataset.rtl || 'false';

    document.querySelector('#personalized-text-pop-up .font-file').value = file;
    document.querySelector('#personalized-text-pop-up .font-name').value = name;
    document.querySelector('#personalized-text-pop-up .font-reverse').value = rtl;
    document.querySelectorAll('#personalized-text-pop-up .font-selector .selected-font').forEach((selectedFont) => selectedFont.classList.remove('selected-font'));
    font.classList.add('selected-font');
    closeFontSelector();
    renderText();
});

clickEvent('#personalized-text-pop-up .color', true, function(color) {
    let code = color.dataset.code;
    let id = color.dataset.id;
    let button = document.querySelector('#personalized-text-pop-up .close-color-selector');
    let orientation = document.querySelector('#personalized-text-pop-up .font-orientation');
    let buttonOrientation = document.querySelector('#personalized-text-pop-up .change-orientation');

    document.querySelector('#personalized-text-pop-up .font-color').value = code;
    document.querySelector('#personalized-text-pop-up .font-color-id').value = id;
    document.querySelectorAll('#personalized-text-pop-up .color-selector .selected-color').forEach((selectedColor) => selectedColor.classList.remove('selected-color'));
    color.classList.add('selected-color');
    button.style.color = code;
    closeColorSelector();

    if (id == 104 || id == 106 || id == 107 || id == 108 || id == 109) {
        buttonOrientation.classList.remove('bg-primary', 'border-primary', 'text-white');
        buttonOrientation.classList.add('border-dark');
        buttonOrientation.disabled = true;
        orientation.value = 'normal';
    } else if (buttonOrientation.disabled) {
        buttonOrientation.disabled = false;
    }

    renderText()
});

let timeOutCustomText;
keyupEvent('#personalized-text-pop-up .text',true, function() {
    clearTimeout(timeOutCustomText);
    timeOutCustomText = setTimeout(() => renderText(), 300);
});

clickEvent('#personalized-text-pop-up .change-orientation', true, function(button) {
    let fontOrientation = document.querySelector('#personalized-text-pop-up .font-orientation')
    let mirrored = fontOrientation.value === 'reversed';

    if (mirrored) {
        button.classList.remove('bg-primary', 'border-primary', 'text-white');
        button.classList.add('border-dark');
        fontOrientation.value = 'normal';
    } else {
        button.classList.remove('border-dark');
        button.classList.add('bg-primary', 'border-primary', 'text-white');
        fontOrientation.value = 'reversed';
    }
    renderText();
});

let timeOutWidth;
keyupEvent('#personalized-text-pop-up .width', true, function () {
    clearTimeout(timeOutWidth);
    document.querySelector('#personalized-text-pop-up .height').value = '';
    timeOutWidth = setTimeout(() => setSizes(), 300);
});

let timeOutHeight;
keyupEvent('#personalized-text-pop-up .height', true, function () {
    clearTimeout(timeOutHeight);
    document.querySelector('#personalized-text-pop-up .width').value = '';
    timeOutHeight = setTimeout(() => setSizes(), 300);
});

clickEvent('#personalized-text-pop-up .btn-add-to-cart', true, function () {
    let price = parseFloat(document.querySelector('#personalized-text-pop-up .btn-add-to-cart .price').dataset.price);
    if (price <= 0) return;
    let preview = document.querySelector('#personalized-text-pop-up .preview-text');
    let svg = new XMLSerializer().serializeToString(preview.querySelector('svg'));
    let mirrored = document.querySelector('#personalized-text-pop-up .font-orientation')
        ? document.querySelector('#personalized-text-pop-up .font-orientation').value : 'normal';

    dispatchCustomEvent(
        'upSellingPersonalizedTextAddToCart',
        {
            productId: document.querySelector('#personalized-text-pop-up .product-id').value,
            width: document.querySelector('#personalized-text-pop-up .width').value,
            height: document.querySelector('#personalized-text-pop-up .height').value,
            text: document.querySelector('#personalized-text-pop-up .text').value,
            font: document.querySelector('#personalized-text-pop-up .font-name').value,
            color: document.querySelector('#personalized-text-pop-up .font-color-id').value,
            mirrored: (mirrored === 'reversed'),
            rightToLeft: document.querySelector('#personalized-text-pop-up .font-reverse').value,
            fontFile: document.querySelector('#personalized-text-pop-up .font-file').value,
            colorHex: document.querySelector('#personalized-text-pop-up .font-color').value,
            svgPreview: svg,
            price: formatPrice(price)
        }
    )
});

function closeFontSelector()
{
    return new Promise(async function (resolve) {
        let button = document.querySelector('#personalized-text-pop-up .close-font-selector');
        let fontSelector = document.querySelector('#personalized-text-pop-up .font-selector');

        await slideUp(fontSelector);
        button.classList.remove('close-font-selector', 'text-primary', 'border-primary');
        button.classList.add('open-font-selector', 'border-dark');
        document.querySelectorAll('#personalized-text-pop-up .font-group-body').forEach((fontGroupBody) => hideElement(fontGroupBody));
        resolve();
    });
}

function closeColorSelector()
{
    return new Promise(async function (resolve) {
        let button = document.querySelector('#personalized-text-pop-up .close-color-selector');
        let colorSelector = document.querySelector('#personalized-text-pop-up .color-selector');

        await slideUp(colorSelector);
        button.classList.remove('close-color-selector');
        button.classList.add('open-color-selector');
        resolve();
    });
}

async function renderText()
{
    let preview = document.querySelector('#personalized-text-pop-up .preview-text');
    let loader = document.querySelector('#personalized-text-pop-up .loader');
    let text = document.querySelector('#personalized-text-pop-up .text').value;
    let fontFile = document.querySelector('#personalized-text-pop-up .font-file').value;
    let color = document.querySelector('#personalized-text-pop-up .font-color').value;
    let rightToLeft = document.querySelector('#personalized-text-pop-up .font-reverse').value;
    let price = document.querySelector('#personalized-text-pop-up .price');
    let widthInput = document.querySelector('#personalized-text-pop-up .width');
    let heightInput = document.querySelector('#personalized-text-pop-up .height');

    preview.innerHTML = '';
    if (!text) {
        price.innerHTML = '0';
        price.dataset.price = '0';
        widthInput.value = '';
        heightInput.value = '';
        return;
    }
    loader.classList.remove('hidden');
    loader.classList.add('d-flex');

    let params = {text: text, fontFile: fontFile, color: color, rightToLeft: rightToLeft};
    let textPreview = await getTextPreview(params);
    if (!textPreview) return;
    preview.innerHTML = textPreview;

    let svg = preview.querySelector('svg');
    let viewBox = svg.getAttribute('viewBox').split(' ');
    preview.style.width = viewBox[2] + "px";
    preview.style.height = viewBox[3] + "px";
    applyTextModifiers();
    loader.classList.remove('d-flex');
    loader.classList.add('hidden');
    preview.classList.remove('hidden');
    setSizes();
}

function setSizes()
{
    let widthInput = document.querySelector('#personalized-text-pop-up .width');
    let heightInput = document.querySelector('#personalized-text-pop-up .height');
    let width = widthInput.value;
    let height = heightInput.value;
    let preview = document.querySelector('#personalized-text-pop-up .preview-text svg');
    let svg = preview ? preview.getBoundingClientRect() : null;
    if (!svg) return;
    let svgWidth = svg ? svg.width : null;
    let svgHeight = svg ? svg.height : null;
    if (width) {
        height = ((width * svgHeight) / svgWidth).toFixed(1);
    } else if (height) {
        width = ((height * svgWidth) / svgHeight).toFixed(1);
    }
    widthInput.value = width;
    heightInput.value = height;
    updatePrice();
}

function applyTextModifiers()
{
    let preview = document.querySelector('#personalized-text-pop-up .preview-text');
    let svg = preview.querySelector('svg');
    let color = document.querySelector('#personalized-text-pop-up .font-color').value;
    let orientation = document.querySelector('#personalized-text-pop-up .font-orientation')
        ? document.querySelector('#personalized-text-pop-up .font-orientation').value : 'normal';

    svg.style.color = color;
    if (orientation === 'reversed') preview.classList.add('text-mirrored');
    else preview.classList.remove('text-mirrored');
}

async function updatePrice()
{
    let btn = document.querySelector('#personalized-text-pop-up .btn-add-to-cart');
    let sizeError = document.querySelector('#personalized-text-pop-up .min-size-error');
    let price = btn.querySelector('.price');
    let productId = document.querySelector('#personalized-text-pop-up .product-id').value;
    let widthInput = document.querySelector('#personalized-text-pop-up .width');
    let heightInput = document.querySelector('#personalized-text-pop-up .height');
    let color = document.querySelector('#personalized-text-pop-up .font-color-id').value;
    let width = widthInput.value !== '' ? parseFloat(widthInput.value) : 0;
    let height = heightInput.value !== '' ? parseFloat(heightInput.value) : 0;
    let minWidth = parseFloat(widthInput.dataset.minValue || 2);
    let minHeight = parseFloat(heightInput.dataset.minValue || 2);
    let options = {'width': width, 'height': height, 'color': color};

    if (!width || !height) {
        slideUp(sizeError);
        price.innerHTML = '0';
        price.dataset.price = '0';
        return;
    }

    if (width && height && (width < minWidth || height < minHeight)){
        slideDown(sizeError);
        price.innerHTML = '0';
        price.dataset.price = '0';
        return;
    }

    slideUp(sizeError);
    btn.disabled = true;
    let [priceCalculated] = await calculatePrice(null, 1, options, productId);

    if (priceCalculated) {
        price.dataset.price = priceCalculated;
        price.innerHTML = formatPrice(priceCalculated);
    }
    btn.disabled = false;
}